import { Button, Center, HStack, Text, VStack } from "native-base";
import React from "react";

import EmptyIcon from "@/assets/svgs/empty_product.svg";
import SearchIlustration from "@/assets/svgs/search_ilustration.svg";
import { useAppSelector } from "@/hooks/application/store";

type EmptyCardProps = {
  currentSearch: string;
  onSelectRecentQuery: (query: string) => void;
};

const EmptyCard = ({ currentSearch, onSelectRecentQuery }: EmptyCardProps) => {
  const { globalLastSearches } = useAppSelector((store) => store.lastSearches);
  return (
    <VStack p="4">
      <Text fontSize="md">Buscas recentes:</Text>
      <HStack my="4" flexWrap="wrap">
        {!!globalLastSearches?.length &&
          globalLastSearches.map((query) => (
            <Button
              key={query}
              m="1"
              variant="outline"
              colorScheme="primary"
              rounded="full"
              onPress={() => onSelectRecentQuery(query)}>
              {query}
            </Button>
          ))}
      </HStack>
      {currentSearch ? (
        <Center>
          <EmptyIcon width={250} height={250} fill="black" viewBox="0 0 500 500" />
          <Text fontSize="lg" py="2" textAlign="center">
            Nenhum resultado encontrado para {currentSearch}!
          </Text>
        </Center>
      ) : (
        <Center>
          <SearchIlustration width={250} height={250} fill="black" viewBox="0 0 600 600" />
          <Text fontSize="lg" py="2" textAlign="center">
            Busque por produtos ou estabelecimentos
          </Text>
        </Center>
      )}
    </VStack>
  );
};

export default EmptyCard;
